import React from 'react';
import { Box, Typography } from '@mui/material';
import T from '../theme';
import { ContactCards, WhyThisMatters } from '../components/Shared.jsx';

export function ContactOwner({ data }) {
  const { contactsFound = [], missingContacts = [], issues = [], summary } = data;

  return (
    <Box>
      {contactsFound.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Contacts Found</Typography>
          <ContactCards contacts={contactsFound.map((c) => ({ type: c.type, value: c.value, confidence: c.confidence, source: c.source }))} />
        </Box>
      )}

      {missingContacts.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.warning, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>⚠ Missing Contacts</Typography>
          {missingContacts.map((mc, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.5, background: 'rgba(234,179,8,0.07)', border: `1px solid rgba(234,179,8,0.25)`, borderRadius: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.25 }}>
                <Box sx={{ px: 1, py: 0.25, background: 'rgba(234,179,8,0.2)', color: T.warning, borderRadius: 4, fontSize: 11, fontWeight: 600, textTransform: 'uppercase' }}>{mc.type}</Box>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.text }}>{mc.suggestion}</Typography>
              </Box>
              <Typography sx={{ fontSize: 12, color: T.textSecondary }}>{mc.reasonWhy}</Typography>
            </Box>
          ))}
        </Box>
      )}

      {issues.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.error, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1 }}>Issues</Typography>
          {issues.map((iss, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.5, background: 'rgba(239,68,68,0.07)', border: `1px solid rgba(239,68,68,0.25)`, borderRadius: 1 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.text }}>{iss.issue}</Typography>
              <Typography sx={{ fontSize: 12, color: T.textSecondary, mt: 0.25 }}>Impact: {iss.impact} · Fix: {iss.fix}</Typography>
            </Box>
          ))}
        </Box>
      )}

      {summary && (
        <Box sx={{ mb: 3, p: 2, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 1 }}>
          <Typography sx={{ fontSize: 13, color: T.textSecondary }}>{summary}</Typography>
        </Box>
      )}

      <WhyThisMatters text="Direct contact enables partnerships, sponsorships, and audience collaborations." citations={data.expertCitations} />
    </Box>
  );
}
